import { capitalDesignTokens, createTypedSxStyles } from "@opengov/capital-mui-theme";

export const styles = createTypedSxStyles({
  container: {
    display: "flex",
    justifyContent: "flex-end",
    px: "8px",
  },
  learnAboutResults: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    paddingBottom: "16px",
    color: capitalDesignTokens.foundations.colors.gray700,
  },
  infoIcon: {
    color: capitalDesignTokens.foundations.colors.brand700,
  },
});
